import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IFinalsPageDataResult {
  fetch: {
    Common: {
      Finals: {
        Image: {
          src: string;
        } | null;
        Finalists: Array<{
          Country: string;
          CountryCode: string;
          Year: string;
        }> | null;
      } | null;
    };
    Country: {
      FinalsPage: {
        Title: string;
        Content: string;
        PastWinnersTitle: string;
      };
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export type WithFinalsPageQueryProps = QueryResult<IFinalsPageDataResult>;

class FinalsPageQuery extends Query<IFinalsPageDataResult, IVariables> {}

const withFinalsPageQuery = <P extends WithFinalsPageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, WithFinalsPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <FinalsPageQuery
      query={queries.GET_FINALS_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </FinalsPageQuery>
  );
};

export default withFinalsPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withFinalsPageQuery.tsx